import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { TherapistAction } from 'src/redux/actions/constant';
import therapistSchedulingServices from 'src/services/apiServices/therapist-scheduling-services/therapist-scheduling-services';

function* getAllTherapistDiciplineList(action: any): SagaReturnType<any> {
    try {
        const response = yield call(therapistSchedulingServices.getAllTherapistDiciplineList, action.payload);
        if (response?.status === 200) {
            yield put({ type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_SUCCESS, payload: response.data });
        } else {
            throw response.data;
        }
    } catch (error) {
        yield put({ type: TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_FAILURE, payload: error });
    }
}

function* getAllTherapistDiciplineListSaga() {
    yield takeEvery(TherapistAction.GET_ALL_THERAPIST_DICIPLINE_TYPE_REQUEST, getAllTherapistDiciplineList);
}

export default getAllTherapistDiciplineListSaga;
